import { render, staticRenderFns } from "./LoginPostReset.vue?vue&type=template&id=5aec4e5b&scoped=true&"
import script from "./LoginPostReset.vue?vue&type=script&lang=js&"
export * from "./LoginPostReset.vue?vue&type=script&lang=js&"
import style0 from "./LoginPostReset.vue?vue&type=style&index=0&id=5aec4e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec4e5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
